"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationHandlerService = /** @class */ (function () {
    function NotificationHandlerService(callback) {
        this.callback = callback;
        this.notifications = [];
    }
    NotificationHandlerService.prototype.AddNotification = function (notification) {
        if (!this.notifications.includes(notification)) {
            this.notifications.push(notification);
            this.callback();
        }
    };
    NotificationHandlerService.prototype.HasNotification = function () {
        return this.notifications.length > 0;
    };
    NotificationHandlerService.prototype.DismissNotification = function (notification) {
        this.notifications.splice(this.notifications.indexOf(notification));
        this.callback();
    };
    return NotificationHandlerService;
}());
exports.NotificationHandlerService = NotificationHandlerService;
var NotificationHandler = new NotificationHandlerService(function () { });
var NotificationHandlerServiceProvider = /** @class */ (function () {
    function NotificationHandlerServiceProvider() {
        this.service = null;
    }
    NotificationHandlerServiceProvider.prototype.GetInstance = function () {
        var _a;
        return _a = this.service, (_a !== null && _a !== void 0 ? _a : NotificationHandler);
    };
    NotificationHandlerServiceProvider.prototype.Set = function (callback) {
        this.service = new NotificationHandlerService(callback);
        this.service.notifications = NotificationHandler.notifications;
    };
    return NotificationHandlerServiceProvider;
}());
;
exports.NotificationHandlerProvider = new NotificationHandlerServiceProvider();
//# sourceMappingURL=NotificationHandlerService.js.map